/**
 * Taskbar app folders — the bits both the API and the SPA need to agree on.
 *
 * A folder's colour is a KEY into this palette, never a hex: the server
 * validates the key, the client resolves it to whatever the current theme
 * wants that colour to look like, and a palette change is one edit here.
 */
export const FOLDER_COLOR_KEYS = ['violet', 'blue', 'teal', 'green', 'amber', 'rose', 'slate'] as const
export type FolderColorKey = (typeof FOLDER_COLOR_KEYS)[number]

export function isFolderColorKey(v: unknown): v is FolderColorKey {
  return typeof v === 'string' && (FOLDER_COLOR_KEYS as readonly string[]).includes(v)
}
